import { render, staticRenderFns } from "./BatteryCapacityDialog.vue?vue&type=template&id=252a39bd&lang=pug&"
import script from "./BatteryCapacityDialog.vue?vue&type=script&lang=ts&"
export * from "./BatteryCapacityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports